import React, { useState, useEffect, useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import formimg from "../Forms/Performance-Appraisal-Templates-1-1013x439 1.svg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../config";

function PrimaryCategory() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [showToast, setShowToast] = useState(false);

  const navigate = useNavigate();
  const usernameRef = useRef(null);

  const handleSubmit = async (values) => {
    setFormData(values); // Store form data before displaying the modal
    setShowModal(true); // Show the confirmation modal
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConfirmSubmit = async () => {
    try {
      const response = await fetch(`${baseURL}/addcategory`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setFormData(null);
        setShowModal(false);
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          navigate("/createTemplateTab");
        }, 3000);

        // window.location.href = "/createTemplateTab";
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          categoryname: "",
        }}
        validationSchema={Yup.object({
          categoryname: Yup.string().required("Category name is required"),
        })}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <div className="container">
            <h4 className="text-start  pb-2">Create Category</h4>
            <div className="col-lg-12  mt-1 m-5 mt-4 pt-3">
              <form noValidate onSubmit={handleSubmit}>
                <div className="row h-75">
                  <div className="col-lg-5 ">
                    <label className="formlabel">
                      Primary Category<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${
                        touched.categoryname && errors.categoryname
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Enter title"
                      name="categoryname"
                      value={values.categoryname}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.categoryname && errors.categoryname ? (
                      <div className="text-danger">{errors.categoryname}</div>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-11 text-end mt-4 pb-3">
                  <Button
                    className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                    type="submit"
                  >
                    Save
                  </Button>
                  <a
                    href="/createTemplateTab"
                    className="text-decoration-none "
                  >
                    {" "}
                    <Button
                      type="button"
                      className="btn cancelbtn ml-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </Button>
                  </a>
                </div>
              </form>
            </div>
          </div>
        )}
      </Formik>

      {/* Confirmation Modal */}
      <div className="col-lg-12">
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Do You Want to Confirm the changes?</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleConfirmSubmit}>
              Yes
            </Button>
            <Button variant="secondary" onClick={handleCloseModal}>
              No
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      <div>
        <ToastContainer position="top-center" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
            className="bg-success text-white"
          >
            <Toast.Header>
              <span className="me-2">✔️</span> {/* Unicode tick mark */}
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Success!, data updated successfully!</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </>
  );
}

export default PrimaryCategory;
